import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Trophy } from "lucide-react";

export default function Members() {
  const [members, setMembers] = useState([]);
  useEffect(() => { (async () => {
    const { data } = await api.get("/users");
    setMembers(data);
  })(); }, []);
  return (
    <Layout>
      <div className="flex items-center gap-3 mb-6">
        <Trophy strokeWidth={3} className="w-7 h-7"/>
        <h1 className="font-fredoka text-4xl font-bold">Leaderboard</h1>
      </div>
      <div className="grid gap-3">
        {members.map((m, i) => (
          <div key={m.user_id} data-testid={`member-row-${i}`} className="brut-card p-4 bg-white flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full border-2 border-black bg-lilac flex items-center justify-center font-fredoka font-bold">
                {i + 1}
              </div>
              {m.picture && <img src={m.picture} alt="" className="w-10 h-10 rounded-full border-2 border-black object-cover"/>}
              <div>
                <div className="font-fredoka font-bold">{m.name}</div>
                {m.is_admin && <span className="chip bg-peach">admin</span>}
              </div>
            </div>
            <div className="font-fredoka text-2xl font-bold">{m.points} pts</div>
          </div>
        ))}
      </div>
    </Layout>
  );
}
